<div #primary class="mat-button mat-primary" style="display: none"></div>
<ng-container *grecoLet="drawSpots$ | async"></ng-container>
<div class="room-image">
  <canvas #canvas></canvas>
</div>
